export default {
  type: "Editor",
  label: "Field Editor",
  description: "An Editor component displayed in the content type",
  fields: [
    {
      id: "id",
      label: "ID",
      type: "Text",
      required: true,
      description:
        "The unique id of the editor ( as registered with addFieldEditor() )",
    },
    {
      id: "label",
      label: "Label",
      type: "Text",
      required: true,
      description: "The editor display name",
    },
    {
      id: "description",
      label: "Description",
      type: "Text",
      required: true,
      multiline: true,
      description: "Tell the user what this editor does",
    },
    {
      id: "group",
      type: "Text",
      label: "Group",
      options: "{{ContentType.fieldGroups}}",
      description: "Add this Editor to a group for better organization.",
    },
    {
      id: "render",
      label: "Render",
      type: "Object",
      multiple: false,
    },
  ],
}
